import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/material/styles';
import { PROMETHEAN_NEUTRAL_DARK_GREY } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_EYEBROW_UPPERCASE } from '../styles/typography/typography';
import MenuList from '@mui/material/MenuList';
export var StyledMenuList = styled(MenuList)(function () {
  return {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden auto!important',
    '&.MuiList-padding': {
      paddingTop: 2,
      paddingBottom: 2
    },
    '> .MuiTypography-root': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_EYEBROW_UPPERCASE), {}, {
      padding: '6px 16px'
    }),
    '> li': {
      margin: '2px 0'
    },
    '.MuiDivider-root': {
      borderColor: PROMETHEAN_NEUTRAL_DARK_GREY,
      marginTop: 6,
      marginBottom: 6
    }
  };
});